const findBankOfficeEn = {
  'findBankOffice': 'Find a branch',
};

export default findBankOfficeEn;
